const DEFAULT_BODY_PADDING = 20;
const DEFAULT_FOOTER_HEIGHT = 94;

export function resizePanel(panelBodyRef, isWithFooter, isMobileWidth) {
  const thisPanel = panelBodyRef.current;
  if (thisPanel && typeof thisPanel.getBoundingClientRect !== "undefined") {
    let minHeight = window.innerHeight - thisPanel.getBoundingClientRect().top - DEFAULT_BODY_PADDING;
    if (isWithFooter) minHeight -= DEFAULT_FOOTER_HEIGHT;
    thisPanel.style.minHeight = isMobileWidth ? "auto" : minHeight + "px";
  }
}
